import { Blue, Gray, White } from '@constants/color';
import { css } from '@emotion/react';

export const container = css({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  rowGap: '24px',
  minWidth: '256px',
  maxWidth: '256px'
});

export const imageContainer = css({
  position: 'absolute',
  width: '256px',
  height: '360px',
  // backgroundColor: Gray.Gray100,
  borderRadius: '8px',
  overflow: 'hidden',
  zIndex: -1
});

export const mainContainer = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'center',
  padding: '8px',
  height: '336px',
  borderColor: 'transparent',
  borderWidth: '4px',
  borderStyle: 'solid',
  borderRadius: '8px'
});
export const mainContainerFocused = css({
  borderColor: Blue.Blue60
});

export const bottomContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '10px',
  paddingLeft: '10px'
});

export const image = css({
  display: 'none',
  width: '100%',
  height: '100%',
  objectFit: 'cover'
});
export const imageLoaded = css({
  display: 'initial'
});
export const defaultImage = css({
  width: '100%',
  height: '100%',
  objectFit: 'cover'
});
export const name = css({
  color: White.White10,
  fontSize: '28px',
  fontWeight: 500
});
export const major = css({
  color: Gray.Gray60,
  fontSize: '20px',
  fontWeight: 500
});
export const hospitalName = css({
  color: White.White10Alpha70,
  fontSize: '20px',
  fontWeight: 500,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
